import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class WarehouseAuthService {
    constructor(private http: AuthHttp) { }

    getWarehouseAuthsWithName(groupId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('groupId', groupId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "WarehouseAuth/GetWarehouseAuthsWithName", options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/config/warehouse-auth.service.ts